import styled from 'styled-components';
import MaterialAvatar from '@material-ui/core/Avatar';

export const UpgradeWrapper = styled.div`
  padding-top: 20px;
`;

export const MainTitle = styled.div`
    position: absolute;
    top: 5%;
    left: 5%;
    font-family: 'helvetica';
    font-size: 20px;
    color: ${props => props.color};
`;

export const MainWrapper = styled.div`
    background-color: ${props => props.backgroundColor || '#fff'};
    height:${props => (props.type === 'calendly' ? '91%' : '80%')};
    border-radius: 10px;
    width: 90%
    max-width: ${props => (props.type === 'calendly' ? '90%' : '600px')};
    margin: 0 auto;
    padding: 20px 0px 10px;
    
    iframe {
      position: relative;
      height: 650px;
      width: 100%;
    }
    
`;

export const Description = styled.div`
    width: 90%;
    margin: 30px 5%;    
    font-family: 'helvetica';
    font-size: 16px;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 60px;
    margin: 20px auto;
`;

export const ButtonNextWrapper = styled.div`    
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 60px;
    margin: 20px auto;
`;

export const Button = styled.div`
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    width: 40%;
    border-radius: 5px;
    background-color: ${props => (props.type === 'reject' ? 'red' : props.backgroundColor || '#fff')};
    height: 100%;
    color: ${props => (props.type === 'reject' ? '#fff' : props.backgroundColor ? '#fff' : props.color)};
    text-align: center;
    padding: 5%;
    font-size: 13px;
    font-family: 'helvetica';
    font-weight: 600;
    overflow-wrap: break-word; 
    vertical-align: center;
    opacity: ${props => (props.disabled ? '0.6' : 'none')};
`;

export const Image = styled.div`
    width: 90%;
    left: 5%;
    top: 10%;
    right: 5%;
    height: 30%;
    margin-bottom: 10px;
    position: relative;

    img {
        height: 100%;
        width: 100%;
    }
`;
export const Title2 = styled.div`
    position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 10%;
    font-size: 16px;
    font-family: 'helvetica';
    font-weight: 600;
    color: #fff;
    margin-top: 10px;
`;
export const InputTitle = styled.div`
    position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 20px;
    font-size: 16px;
    font-family: 'helvetica';
    font-weight: 600;
    color: #fff;
    margin-top: 3%;
`;
export const ErrorText = styled.div`
    position: relative;
    left: 5%;
    font-size: 10px;
    color: #d32f2f;
`;
export const MembersTitle = styled.div`
    position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 20px;
    font-size: 16px;
    font-family: 'helvetica';
    font-weight: 600;
    color: #fff;
    margin-top: 15px;
`;

export const InputText = styled.div`
    display: flex;
    position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    margin-bottom: 10px;
    input {
      border: 0;
      outline: 0;
      background: transparent;
      border-bottom: 3px solid #fff;
      color: white;
      width: 100%;
      height: 50%;
      font-size: 18px;
    }
    i {
      margin-left: 5px;
      font-size: 18px;
    }
`;

export const InputDescription = styled.div`
    display: flex;
    position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 15%;
    textarea {
      margin-top: 5px;
      width: 100%;
      font-size: 15px;
    }
    i {
      margin-left: 5px;
      font-size: 18px;
    }
`;

export const MembersWrapper = styled.div`
  padding: 20px 5%;

  .avatar_bubble {
    margin: 10px 15px 0 0;
    opacity: 0.5;

    &.selected {
      opacity: 1;
    }
  }
`;

export const AddUsers = styled.div`
  border: 2px dashed #fff;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  padding-top: 9px;
  margin: 10px 0px 0 0;

  i {
    color: white;
   }
`;

export const CalendTitle = styled.div`
   position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 10%;
    font-size: 16px;
    font-family: 'helvetica';
    font-weight: 600;
    color: #fff;
    margin-top: 10px;
    margin-bottom: 20px;
`;

export const OptionsTitle = styled.div`
   position: relative;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 10%;
    font-size: 16px;
    font-family: 'helvetica';
    color: #fff;
    margin-top: 10px;
    margin-bottom: 30px;
`;

export const CheckWrapper = styled.div`
  padding: 0 20px;
`;

export const Checkbox = styled.div`
  width: 100%;
  input {
    position: relative;
    top: 17px;
  }
  margin-bottom: 20px;
`;
export const CheckboxText = styled.div`
  position: relative;
  width: 90%;
  left: 5%;
  right: 5%;
  font-size: 16px;
  font-family: 'helvetica';
  font-weight: ${props => (props.type === 'title' ? '600' : '100')};
  color: #fff;
  a {
    text-decoration: underline;
    color: #fff;
    cursor: pointer;
  }
`;

export const ButtonNext = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    position: relative;
    bottom: 3%;
    width: 35%;
    left: 33%;
    right: 25%;
    background-color: #fff;
    height: 7%;
    color: ${props => props.color};
    text-align: center;
    font-size: 16px;
    line-height: 37px;
    font-family: 'helvetica';
    font-weight: 600;
    overflow-wrap: break-word; 
    vertical-align: center;
`;
export const BackArrow = styled.div`
  position: relative;
  top: 2%;
  left: 5%;
  vertical-align: middle;

  i {
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
`;

export const AvatarUser = styled.div`
  width: 20%;
  height: 100%;
  background-image: url(${props => props.src});
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  display: inline-block;
  margin: 5px;
  background-color: #f0f0f0;
  cursor: pointer;
  opacity: ${props => (props.selected < 0 && '0.3')};
`;

export const AvatarUserText = styled(MaterialAvatar)`
  && {
    width: 20%;
    height: 100%;
    background-color: #999;
    font-size: 30px;
    margin: 20px auto;
    text-transform: uppercase;
    display: inline-block;
    margin: 5px;
    cursor: pointer;
    padding: 8px;
    text-align: center;
    opacity: ${props => (props.selected < 0 && '0.3')};
  }
`;

export const ErrorMessage = styled.div`
    border: 2px solid #fff;
    padding: 5px;
    color: white;
    font-size: 15px;
    width: 35%;
    left: 33%;
    right: 25%;
    text-align: center;
    position: relative;
    font-weight: 600;
    top: -16px;
    background-color: red;
`;

export const SeeMore = styled.div`
  position: relative;
  width: 90%;
  left: 5%;
  right: 5%;
  font-size: 16px;
  font-family: 'helvetica';
  font-weight: 600;
  text-decoration: underline;
  color: #fff;
`;



// WEBPACK FOOTER //
// ./src/routes/Upgrade/components/styles.js